/* eslint-disable */
/// This file is auto generated - do not edit manually
export const VeryBad = 'Website.ProductReview.Rating.VeryBad';
export const Bad = 'Website.ProductReview.Rating.Bad';
export const Ok = 'Website.ProductReview.Rating.Ok';
export const Good = 'Website.ProductReview.Rating.Good';
export const VeryGood = 'Website.ProductReview.Rating.VeryGood';
